import Vue from 'vue'
import Router from 'vue-router'
import index from '../components/pages/index'
import two from '../components/pages/two'
import fenxiang from '../components/pages/fenxiang'

Vue.use(Router)

export default new Router({
    mode: 'hash',
    base: '/app/', //服务器文件位置根目录
    routes: [{
        path: '/index',
        name: 'index',
        component: index,
        meta: { keepAlive: true }
    }, {
        path: '/',
        name: 'two',
        component: two,
        meta: { keepAlive: false }
    },{
        path: '/fenxiang',
        name: 'fenxiang',
        component: fenxiang,
        meta: { keepAlive: false }
    }]
})


// WEBPACK FOOTER //
// ./src/router/index.js